
import { Company } from 'identity-webapi-client';
import { Component } from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { animate, keyframes, transition, trigger } from '@angular/animations';
import * as kf from '../../../core/keyframes';
import { IProduct2, ITag } from 'situview-webapi-client';
import { FormControl } from '@angular/forms';
import { 
  FileParameter, IProduct, ListProductsRequest,
  ResourceType, Tag, Range
} from 'situview-webapi-client';
import { 
  AuthService, BreadcrumbService, Utils, 
  CustomSituViewWebApiClient, NotificationService, StateService,
  TaggingService, ProductService
} from 'src/app/services';
import { GetReportRequest, GetReportResponse, ReportType, SituAnalyticsWebApiClient } from 'situanalytics-webapi-client';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';

@Component({
  selector: 'products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.less'],
  animations: [
    trigger('cardAnimator', [
      transition('* => wobble', animate(1000, keyframes(kf.wobble))),
      transition('* => swing', animate(1000, keyframes(kf.swing))),
      transition('* => jello', animate(1000, keyframes(kf.jello))),
      transition('* => zoomOutRight', animate(1000, keyframes(kf.zoomOutRight))),
      transition('* => slideOutLeft', animate(1000, keyframes(kf.slideOutLeft))),
      transition('* => rotateOutUpRight', animate(1000, keyframes(kf.rotateOutUpRight))),
      transition('* => flipOutY', animate(1000, keyframes(kf.flipOutY))),
      transition('* => headShake', animate(1000, keyframes(kf.headShake)))
    ])
  ]
})

export class ProductsListComponent extends SituBaseComponent {
  addOnBlur = false;
  resourceTypeEnum = ResourceType.Product
  isDarkMode: boolean = true;
  selectMode: boolean = false;
  dragging: boolean = false;
  // isSitu: boolean = false;
  // isPartnerAdmin: boolean = false;

  isNotTagFeed: boolean = true;
  filteredTagIds: string[] = [];
  selectedTag: Tag | undefined;

  tagsDnD: string[] = ["tags"];
  productsDnD: string[] = ["products"];

  private _selectAll: boolean = false;
  public get selectAll(): boolean {
    return this._selectAll;
  }
  public set selectAll(value: boolean) {
    this._selectAll = value;
    this.productsDataSource.data.forEach(prod => {
      (prod as any).selected = value;
    });
  }

  //tags: Tag[] = [];
  filteredTags: Tag[] = [];
  get tags(): Tag[] {
    return this.taggingService.tags.filter(t => t.isDeleted == false
      && t.resourceType === this.resourceTypeEnum);
  }

  searchTermTag = "";
  searchFieldTag = new FormControl();

  doTagFilter = (value: string) => {
    if (value) {
      let searchTerm = value.trim().toLowerCase();
      this.filteredTags = this.taggingService.tags.filter(t => { return t.isDeleted == false &&
        t.resourceType === this.resourceTypeEnum &&
        t.name?.toLowerCase().includes(searchTerm)
      });
    } else {
      this.filteredTags = this.taggingService.tags.filter(t => t.isDeleted == false
        && t.resourceType === this.resourceTypeEnum);
    }
  }

  colorPool: string[] = [];
  totalsChartLoading: boolean = false;
  public totalsChartLabels: string[] = [];
  public totalsChartData: any[] = [];
  public totalsChartColors: Array<any> = [];

  viewsChartLoading: boolean = false;
  public viewsChartData: Array<any> = [];
  public viewsChartLabels: Array<string> = [];
  public viewsChartColors: Array<any> = [];

  private _loading = false;
  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  viewControls = {
    pageIndex: 0,
    pageSize: 100,
    totalItems: 0,
    pageSizeOptions: [25, 50, 100],
    displayedColumns: ['description', 'sku', 'displaySku', 'type', 'brand', 'disabled', 'cta']
  } as ProductsListViewControls;

  enabledOnly: boolean = true;
  previousSearchTerm = "";
  searchTerm = "";
  selectedCompany: Company | undefined;
  admin = false;
  productsDataSource = new MatTableDataSource<IListProduct>();
  file: any;
  filename: string | undefined;

  animateSelect: string = '';
  animateGetStarted: string = '';
  selectModeAction: string = '';

  constructor(
    authService: AuthService,
    stateService: StateService,
    private situViewWebApiClient: CustomSituViewWebApiClient,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private taggingService: TaggingService,
    private situAnalyticsClient: SituAnalyticsWebApiClient,
    private productService: ProductService) {
      super(authService, stateService);
      this.colorPool = Utils.getColorPool();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.isSituUser) {
      this.viewControls.displayedColumns.push('tags', 'checked');
    }
  }

  protected onSelectedCompanyChange(): void {
    if (this.isSituUser) {
      this.loadProducts();
    }
    this.loadPopularProductsChart();
    this.loadViewTotals();
    this.doTagFilter("");
  }

  startGetStartedAnimation(state: string) {
    if (!this.animateGetStarted) {
      this.animateGetStarted = state;
    }
  }

  startAnimation(state: string) {
    if (!this.animateSelect) {
      this.animateSelect = state;
    }
  }

  resetAnimationState() {
    this.animateSelect = '';
  }

  dragProducts(started: boolean) {
    this.dragging = started;
  }

  drop(event: CdkDragDrop<string[]>) {
    alert(`${event.previousContainer.data[event.previousIndex]} --> ${event.container.data[event.currentIndex]}`);
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  toggleTagFeed() {
    this.isNotTagFeed = !this.isNotTagFeed;
  }

  toggleSelectMode() {
    this.selectMode = !this.selectMode;
    if (!this.selectMode) {
      this.selectAll = false;
      this.selectedTag = undefined;
    } else {
      this.startAnimation('headShake');
    }
  }
  
  toggleSelectAll() {
    this.selectMode = !this._selectAll;
    this.selectAll = !this._selectAll;
  }

  getProductsSelected() {
    return this.productsDataSource.data.filter(x => x.selected)?.length;
  }

  selectTag(tag: Tag) {
    if (this.selectMode) {
      this.selectedTag = tag;
    }
  }

  getProductsTagged(tag: Tag) {
    return this.productsDataSource.data.map(x => x.tagIds).filter(x => x !== tag?.id).length;
  }

  loadProducts() {
    this.loading = true;

    let request = new ListProductsRequest();

    if (this.searchTermChanged()) this.resetSearch();
    request.pageNumber = this.viewControls.pageIndex + 1;
    request.pageSize = this.viewControls.pageSize;
    request.searchTerm = this.searchTerm;
    request.enabled = this.enabledOnly;
    request.includeTagsIds = true;
    request.tagFilter = this.filteredTagIds;
    request.companyId = this.selectedCompany?.id;
    this.previousSearchTerm = this.searchTerm;

    return this.productService.ListProducts(request)
      .then((response: any) => {
        this.productsDataSource.data = response.products ?? [];
        if (this.productsDataSource.data.length < 1 && !this.searchTerm) {
          this.startGetStartedAnimation("headShake");
        }
        this.viewControls.totalItems = response.totalItems ?? 0;
        this.loading = false;
      })
      .catch((err: any) => {
        this.loading = false;
      });
  }

  onFileChosen(event: any) {
    var fileExt = event.target.files[0].name.split('.').pop();
    if (fileExt !== 'xlsx') {
      this.showMessage("Only Excel spreadsheets are allowed");
      return;
    }

    let fileParameter: FileParameter[] | null | undefined = [{ data: event.target.files[0], fileName: event.target.files[0].name }];

    this.situViewWebApiClient.importProducts(this.selectedCompany?.id, fileParameter).then((response) => {
      if (response.success) {
        this.showMessage("Product file uploaded");
        this.notificationService.updateImportedProductsNotification();
        this.router.navigate(['/products-import-preview']);
      }
      else {
        this.showMessage("There was an issue importing the product file")
      }
    });
  }

  upload(files: any) {
    this.loading = true;
    if (files.length === 0) {
      this.showMessage(`No file selected.`);
      this.loading = false;
      return;
    }
  }

  onImportProductsClick() {
    document.getElementById("uploaded-product-file")?.click();
  }

  onClickProduct(product: IListProduct) {
    if (this.selectMode) {
      product.selected = !product.selected;
    } else {
      this.router.navigate([`/products/product/${product.id}`]);
  }
  }

  onCopyProduct(product: IListProduct) {
    this.router.navigate([`/products/product/add`], { queryParams: { product: JSON.stringify(product) } });
  }

  onClickAddProduct() {
    this.router.navigate([`/products/product/add`]);
  }

  onClickAddRange() {
    this.router.navigate([`/products/ranges/add`]);
  }

  onPageChange(event: PageEvent) {
    this.viewControls.pageSize = event.pageSize;
    this.viewControls.pageIndex = event.pageIndex;

    this.loadProducts();
  }

  resetSearch() {
    this.viewControls.pageIndex = 0;
    this.viewControls.pageSize = 25;
    this.viewControls.totalItems = 0;
  }

  showMessage(message: string) {
    this.snackBar.open(message, 'Dismiss', {
      duration: 3000
    });
  }

  onCheckBoxChanged() {
    this._selectAll = false;
  }

  totalsLabelFormatter (tick: string) {
    let date = new Date(tick);
    return `${date.getHours()}`;
  }

  canBeEdited(range: Range) {
    return !(range?.logicalExpression && (range?.name === "All" || range?.name === "Unassigned"));
  }

  private searchTermChanged(): boolean {
    return this.searchTerm.toLowerCase() !== this.previousSearchTerm.toLowerCase();
  };

  private loadPopularProductsChart() {
    this.viewsChartLoading = true;
    this.viewsChartColors = [];
    this.viewsChartLabels = [];
    this.viewsChartData = [];
    this.viewsChartColors.push("rgba(56, 163, 165, 1)");
    
    let reportRequest = new GetReportRequest();
    //reportRequest.companyCode = this.selectedCompany?.code;
    reportRequest.companyId = this.selectedCompany?.id;
    reportRequest.type = ReportType.MostPopularProduct;
    reportRequest.timePeriod = 1;
    return this.situAnalyticsClient.getReport(reportRequest)
      .then((renderReportResponse: any) => {
        let response = renderReportResponse as GetReportResponse;
        if (response.success) {
          let dataSet = [];
          for (let key in response.data) {
            let value = response.data[key];
            this.viewsChartLabels.push(key);
            dataSet.push(value);
          }
          this.viewsChartData = [{ data: dataSet, label: "Views" }];
        }
        this.viewsChartLoading = false;
      })
      .catch((err: any) => {
        this.viewsChartLoading = false;
      });
  };

  private loadViewTotals() {
    this.totalsChartLoading = true;
    this.totalsChartColors = [];
    this.totalsChartLabels = [];
    this.totalsChartData = [];
    Utils.shuffleArray(Utils.getColorPool()).forEach(color => {
      this.totalsChartColors.push(color);
    });
    
    let reportRequest = new GetReportRequest();
    //reportRequest.companyCode = this.selectedCompany?.code;
    reportRequest.companyId = this.selectedCompany?.id;
    reportRequest.type = ReportType.DailyProductViewTotal;
    reportRequest.timePeriod = 1;
    return this.situAnalyticsClient.getReport(reportRequest)
      .then((renderReportResponse: any) => {
        let response = renderReportResponse as GetReportResponse;
        if (response.success) {
          let dataSet = [];
          for (let key in response.data) {
            let value = response.data[key];
            this.totalsChartLabels.push(key);
            dataSet.push(value);
          }
          this.totalsChartData = [{ data: dataSet, label: "Total" }];
        }
        this.totalsChartLoading = false;
      })
      .catch((err: any) => {
        this.totalsChartLoading = false;
      });
  }

  public tagClass(tag: Tag): string {
    return this.background(tag?.backgroundColour ?? "") + ' ' + this.border(tag?.borderColour ?? "");
  }

  public background(index: string): string {
    return this.taggingService.tagBackgroundColourClassName(index);
  }

  public border(index: string): string {
    return this.taggingService.tagBorderColourClassName(index);
  }
}

interface ProductsListViewControls {
  pageSize: number;
  pageIndex: number;
  pageNumber: number;
  totalItems: number;
  pageSizeOptions: number[];
  displayedColumns: string[];
}

export interface IListProduct extends IProduct {
  [x: string]: any;
  selected: boolean;
  filtered: boolean;
}

export interface IListProduct2 extends IProduct2 {
  [x: string]: any;
  selected: boolean;
  filtered: boolean;
}

interface IListTag extends ITag {
  selected: boolean;
}

